import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { PageBase } from './helpers/page-base';
import { pages } from '../page-constants';
import { urlForName } from '../../../webmodule-common/other/router';
import { LangPageNotFound } from '../../../localization/scripts/dealer-franchisee/pages/page-not-found-lang';

@customElement('page-not-found')
export class PageNotFound extends PageBase {
  static styles = css`
    :host {
      display: block;
    }

    section {
      padding: 1rem;
      text-align: center;
    }
  `;

  render() {
    return html`
      <section>
        <h1>${LangPageNotFound.pageNotFoundTitle()}</h1>
        <p>
          <a href="${urlForName(pages.home)}">${LangPageNotFound.backToHomeLink()}</a>
        </p>
      </section>
    `;
  }
}
